import { DEVELOPERS } from "constants/developers";

export const isDeveloper = (user) => {
  if (!user) return false;
  return DEVELOPERS.includes(user.userName);
};
